<script setup lang="ts">
import {useForm} from 'vee-validate'

import {useStartupForm} from '@/utils'

const {fields} = useStartupForm()

const isSubmitted = ref(false)
const activeStep = ref<keyof typeof fields>('tip')
const stepData = computed(() => fields[activeStep.value])

const {handleSubmit, values} = useForm({
  keepValuesOnUnmount: true,
})

const onSubmit = handleSubmit(async () => {
  if (stepData.value.next) {
    activeStep.value = stepData.value.next as keyof typeof fields
    return
  }

  await fetch('https://hook.eu1.make.com/g1ex3ka8svwa5rozdoc17cuzcjg39fmj', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(values),
  }).catch((error: Error) => {
    alert(error)
  })

  isSubmitted.value = true
})

function goToPreviousStep() {
  activeStep.value = stepData.value.prev as keyof typeof fields
}
</script>

<template>
  <form novalidate @submit.prevent="onSubmit" class="flex flex-col">
    <div class="w-full max-w-xl rounded-xl bg-white p-8 bordershadow-lg-gray">
      <template v-if="!isSubmitted">
        <div class="mb-4 flex xs:flex-col lg:flex-row">
          <FormTitle :title="stepData.title" :description="stepData.description" />
        </div>

        <div class="flex flex-col gap-y-3">
          <component
            v-for="input of stepData.fields"
            :key="input.id"
            :validation="input.validation"
            :is="input.component"
            :name="input.id"
            v-bind="input.props"
            class="w-full"
          />
        </div>

        <div class="mx-auto flex w-full justify-between pt-8">
          <Action v-if="stepData.prev" intent="normal" @click="goToPreviousStep">
            {{ $t('startup.buttons.previous') }}
          </Action>
          <div v-else></div>

          <Action intent="main" type="submit">
            {{ stepData.next ? $t('startup.buttons.next') : $t('startup.buttons.submit') }}
          </Action>
        </div>
      </template>

      <div v-else class="flex flex-col justify-center pb-8 text-center">
        <img class="mx-auto mb-8 w-2/3" src="/startup/figure.png" alt="" />

        <Heading size="big" class="mb-2">
          {{ $t('startup.form.sections.thank_you.title') }}
        </Heading>
        <Paragraph>
          {{ $t('startup.form.sections.thank_you.paragraph') }}
        </Paragraph>
      </div>
    </div>
  </form>
</template>

<style>
.disabled {
  pointer-events: none;
}
</style>
